// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/shared/detailsList/detailsList.style.scss
// module id = 177
// module chunks = 0 1